<template>
    <component v-if="state=='OK'" :is="currentView"></component>
    <div v-else-if="state=='ERROR'" class="alert alert-danger">{{ errorMessage }}</div>
    <loading v-else-if="state=='LOADING'" text="loading template..."></loading>
</template>

<script>
import loading from './Loading';
import Vue from 'vue'

export default {
  name: 'resourceTemplate',
  props: ["resource", "componentData"],
  data () {
    return {
        state: "LOADING",
        errorMessage: "",
        currentView: null
    }
  },
  mounted() {
    this.refresh();
  },
  components: {
      loading
  },
  methods: {
      refresh() {
          if (this.resource) {
              if (this.resource.data && this.resource.data.children) {
                try {
                    var html = new XMLSerializer().serializeToString(this.resource.data.children[0]);
                    
                    this.currentView = Vue.component("ResourceTemplateCurrentView", {
                        template: html,
                        data: this.componentData
                    });

                    this.state = "OK";
                } catch(e) {
                    this.state = "ERROR";
                    this.errorMessage = "Error deserializing template: " + e;
                }
              } else {
                this.state = "ERROR";
                this.errorMessage = this.resource.error ? this.resource.error : "Unknown error";
              }
          } else {
            this.state = "LOADING";
          }
      }
  },
  watch: {
      resource() {
          this.refresh();
      }
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// ResourceTemplate.vue?081b3690